import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { WSCMiniVM } from './WaterwaySizingMiniVM';
// import { CollapseMenu } from 'cd-eft/components/common/CollapseMenu';
import Draggable from 'react-draggable';
import './waterwaySizingMini.scss';
import { WaterwaySizingComp } from 'cd-eft/components/EFH2/Waterway Sizing Calulator/WaterwaySizingCalculator';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';
import { Collapse, CardBody, Card } from 'reactstrap';

const CollapseLike = (props) => {
    return (
        <div className={props.className ? props.className : 'mb-3'}>
            <div
                className="set-collapse display-flex justify-content-between"
                color="primary"
                aria-controls={props?.bodyContainerId}
                aria-expanded={true}
            >
                <span className={'ml-1'}>
                    {props.showAsHeader ? <h1 className="h5 mt-1 mb-1">{props.title}</h1> : props.title}
                </span>
                <button
                    onClick={props.closeCallback}
                    className="wsc-close-button usa-button usa-button--unstyled"
                >
                    <Icon path={mdiClose} title="" size={1} color="#005ea2" />
                </button>
            </div>
            < Collapse isOpen={true}>
                <div className="collapse-body-container">
                    <div className="collapse-body" id={props?.cardBodyId}>
                        {props.children}
                    </div>
                </div>
            </Collapse>
        </div>
    )
}

const WSCContainerComponent = (props) => {
    const vm = useRef(new WSCMiniVM()).current;
    useEffect(()=>{
        vm.getVegCover();
    },[])
    
    if (vm.displayWSC) {
        return (
            <Draggable
                axis="both"
                handle=".WSC-container-top"
                cancel=".common-input-container, .common-combo-box-component, .usa-radio__label, .wsc-section-header, .usa-button, .usa-accordion__heading"
                bounds=".design-workspace"
            >
                <div className="WSC-container-top waterway-sizing-design-container shadow">
                    <CollapseLike title={'Waterway Sizing Calculator'} cardBodyId="waterway-sizing-design" noIcon={true} className='waterway-sizing-design-class' closeCallback={vm.handleCloseContainer}>
                        <div className="primary-div WSCContainer">
                            <WaterwaySizingComp mode='design' size='small' surfaceDesignerVm={props.surfaceDesignerVm} vegCoverOptions={vm.vegetalCoverOptions}/>
                        </div>
                    </CollapseLike>
                </div>
            </Draggable>
        );
    } else return null;
}


export const WaterwaySizingMini = observer(WSCContainerComponent);